import { useEffect, useState } from 'react'

import { formatOptions } from '../services/helpers'
import { httpPost } from '../services/http'

const DEFAULT_STATE = {
	categories: [],
	filters: [],
	car: null,
	model: null,
	type: null,
	subType: null,
	category: null,
	selectOpened: false,
  status: '',
}

const STATUS_OPTIONS = [{
  label: 'Нове',
  value: 'nowe'
}, {
  label: 'Вживане',
  value: 'używane'
}]

export const useFilters = (props) => {
  const {
    changeFilters,
    changeCLICK,
    searchAll,
    resetData,
    search: searchState,
    changeQueryString,
    getQueryParams = () => ({}),
    changePagination = () => {},
  } = props

	const [state, updateState] = useState(DEFAULT_STATE)

	const setState = (value) => {
		updateState((prevState) => ({
			...prevState,
			...value,
		}))
	}

  const getFormattedQueryData = (list = state.filters) => {
    const { car, category, sort, page, model, type, subType, status } = getQueryParams()
    const carId = car ? (list.find((el) => el.type === 'car' && el.search === car) || {})._id : ''
    const modelId = car ? (list.find((el) => el.search === model) || {})._id : ''
    const typeId = type ? (list.find(el => el.search === type) || {})._id : ''
    const subTypeId = subType ? (list.find(el => el.search === subType) || {})._id : ''
    return {
      car: carId,
      category,
      sort,
      model: modelId,
      page,
      type: typeId,
      subType: subTypeId,
      status,
    }
  }

	useEffect(() => {
		httpPost('categories/getAll')
			.then((res) => {
				setState({ categories: res.data });
			});
		httpPost('filter/getAll')
			.then((res) => {
				setState({
          ...getFormattedQueryData(res.data),
          filters: res.data,
        })
			})

    return () => {
      setState(DEFAULT_STATE)
      resetData()
    }
	}, [])

	const changeSelected = (key, value) => {
		setState({ [key]: value })
	}

  const brandOptions = formatOptions(state.filters.filter((el) => el.type === 'car' && el.name && el.name !== ''))
  const brandSearchOptions = formatOptions(state.filters.filter((el) => el.type === 'car' && el.name && el.name !== ''), 'search')
  const modelOptions = formatOptions(state.filters.filter((el) => el.relative === state.car))
  const categoryOptions = formatOptions(state.categories.filter((el) => !el.parent || el.parent === ''), 'id', 'Name')
  const groupOptions = state.category
    ? formatOptions(state.filters.filter((el) => String(el.type) === String(state.category) + '' && el.name && el.name !== ''))
    : []
  const subGroupOptions = formatOptions(state.filters.filter((el) => el.relative === state.type))

	const search = () => {
		const data = {
      category: state.category || searchState.category,
    }
    const { filters: stateFilters } = state
		data.searchStr = (state.car ? stateFilters.find(el => el._id === state.car).search + ' ' : '')
      + (state.model ? stateFilters.find(el => el._id === state.model).search + ' ' : '')
      + (state.type ? stateFilters.find(el => el._id === state.type).search + ' ' : '')
      + (state.subType ? stateFilters.find(el => el._id === state.subType).search : '')

    const filters = {
      car: (stateFilters.find(el => el._id === state.car) || {}).search || '',
      model: (stateFilters.find(el => el._id === state.model) || {}).search || '',
      type: (stateFilters.find(el => el._id === state.type) || {}).search || '',
      subType: (stateFilters.find(el => el._id === state.subType) || {}).search || '',
      status: state.status,
      sort: searchState.sort,
    }

    changeFilters(filters)
    changePagination({ page: 1 })
		searchAll(data);
		changeCLICK();
    changeQueryString({
      ...filters,
      page: 1,
      category: state.category,
    })
	}

  return {
    changeSelected,
    search,
    filtersData: state,
    filtersOptions: {
      categoryOptions,
      modelOptions,
      brandOptions,
      brandSearchOptions,
      subGroupOptions,
      groupOptions,
      statusOptions: STATUS_OPTIONS
    },
  }
}